import { HttpClient } from '@angular/common/http';
import { Injectable, Injector, EventEmitter } from '@angular/core';
import { map } from 'rxjs/operators';
import { createHttpParams } from '~/infrastructure/http/params';
import { augmentPaging } from '~/infrastructure/paging';
import { SalesOrderListing, SalesOrderSummary, SalesOrderWithCustomerListing } from '~/models/modules/salesOrder';
import { ApiServiceBase, API_NAMES } from '~/services/api';

@Injectable({ providedIn: 'root' })
export class SalesOrdersService extends ApiServiceBase {
  salesOrderAdded: EventEmitter<any> = new EventEmitter();
  constructor(injector: Injector, private http: HttpClient) {
    super(injector);
    this.setBase(API_NAMES.stocks);
  }

  getSalesOrder(id: number) {
    return this.http.get<SalesOrderSummary>(this._url(`/${id}`));
  }

  getSalesOrderListingBySite(siteId: number) {
    return this.http.get<any[]>(this._url(`/site/${siteId}`));
  }

  getOpenApprovedSalesOrderListingBySite(siteId: number) {
    return this.http.get<SalesOrderListing[]>(this._url(`/openApprovedSO/site/${siteId}`));
  }

  getSalesOrderBySite(siteId: number) {
    return this.http.get(this._url(`/site/${siteId}`));
  }

  getSalesOrderWithCustomerListingBySite(siteId: number) {
    return this.http.get<SalesOrderWithCustomerListing[]>(this._url(`/site/withcustomer/${siteId}`));
  }

  getSalesOrderWithCustomerForReturnListingBySite(siteId: number) {
    return this.http.get<SalesOrderWithCustomerListing[]>(this._url(`/site/withcustomerForReturn/${siteId}`));
  }

  getSalesOrders(paramsObj?: any, model?: any) {
    paramsObj = paramsObj || {};
    paramsObj.view = 'summary';
    let params = createHttpParams(paramsObj);

    return this.http.post<SalesOrderSummary[]>(this._url(`/grid-data`), model, { params, observe: 'response' }).pipe(map(augmentPaging));
  }

  getSalesOrdersGridBySite(siteId: number, paramsObj?: any, model?: any) {
    paramsObj = paramsObj || {};
    paramsObj.view = 'summary';
    let params = createHttpParams(paramsObj);

    return this.http.post<SalesOrderSummary[]>(this._url(`/site/${siteId}/grid-data`), model, { params, observe: 'response' }).pipe(map(augmentPaging));
  }

  getOpenApprovedSalesOrdersGridBySite(siteId: number, paramsObj?: any, model?: any) {
    paramsObj = paramsObj || {};
    paramsObj.view = 'summary';
    let params = createHttpParams(paramsObj);

    return this.http.post<SalesOrderSummary[]>(this._url(`/site/${siteId}/open-approved-grid-data`), model, { params, observe: 'response' }).pipe(map(augmentPaging));
  }

  GetSalesOrderByStockItem(stockItemId: number, model: any, paramsObj?: any) {
    paramsObj = paramsObj || {};
    paramsObj.view = 'summary';
    let params = createHttpParams(paramsObj);

    return this.http.post<SalesOrderSummary[]>(this._url(`/StockItems/${stockItemId}/grid-data`), model, { params, observe: 'response' }).pipe(map(augmentPaging));
  }

  GetSalesOrderByCustomer(customerId: number, model: any) {
    return this.http.post<SalesOrderSummary[]>(this._url(`/Customers/${customerId}/grid-data`), model, { observe: 'response' }).pipe(map(augmentPaging));
  }

  GetSalesOrderBackOrderByCustomer(customerId: number, model: any) {
    return this.http.post<SalesOrderSummary[]>(this._url(`/Customers/${customerId}/SoBackOrder/grid-data`), model, { observe: 'response' }).pipe(map(augmentPaging));
  }

  ApproveRejectSalesOrder(id: number, model: any) {
    return this.client.put(this._url(`/${id}/Status`), model);
  }

  SubmitSalesOrder(model: any) {
    return this.client.put(this._url(`/Submit`), model);
  }

  createSalesOrder(model: any) {
    return this.client.post<string>(this._url(), model);
  }

  updateSalesOrder(id: number, model: any) {
    return this.client.put(this._url(`/${id}`), model);
  }

  updateSalesOrderStatus(id: number, model: any) {
    return this.client.put(this._url(`/status/${id}`), model);
  }

  deleteSalesOrder(id: number) {
    return this.client.delete(this._url(`/${id}`));
  }

  deactivateSaleOrder(obj: any) {
    return this.client.put(this._url(`/deactivate`), obj);
  }

  reactivateSaleOrder(obj: any) {
    return this.client.put(this._url(`/reactivate`), obj);
  }

  activedeactivateSaleOrderBatch(obj: any) {
    return this.client.put(this._url(`/batchActivateDeactivate`), obj);
  }


  private _url(v?: string | undefined) {
    v = v || '';
    return this.url(`/SalesOrders${v}`);
  }
}
